import React, { useEffect, useMemo, useState } from "react";
import SectionField from "../section/SectionField";
import styles from "./Formula.module.scss";
import InputTextArea from "components/shared/textArea/InputTextArea";
import FileUploadButton from "components/shared/fileUploadButton/FileUploadButton";
import { useForm, Controller } from "react-hook-form";
import TriggerButton from "components/shared/createTriggerButton/TriggerButton";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateDroppedItems } from "redux/slices/formSlice";
import Button from "components/shared/button/Button";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { setPublish } from "redux/slices/globalSlice";
import { setDroppedItems } from "redux/slices/formSlice";
import { setDroppedItems as setTriggerList } from "redux/slices/triggerSlice";
import { handleFile, randomIntFromInterval } from "utils/utils";
import DeleteIcon from "@mui/icons-material/Delete";

const FormulaComponent = () => {
  const { droppedItems } = useSelector((state) => state.form);
  const { triggerDroppedList } = useSelector((state) => state.trigger);
  const { formId } = useParams();
  const dispatch = useDispatch();
  const { selectedData } = useSelector((state) => state.form);
  const { publish } = useSelector((state) => state?.global);
  const navigate = useNavigate();
  const { register, setValue, control, watch } = useForm({
    defaultValues: {
      allowNA: false,
      answers: [
        { label: "Yes", evaluation: "" },
        { label: "No", evaluation: "" },
      ],
      instructions: selectedData?.instructions || "",
      showInstructions: selectedData?.showInstructions || false,
      enableDependentQuestions: false,
    },
  });


  const currentItem = useMemo(
    () => droppedItems.find((item) => item.id === selectedData.id),
    [droppedItems, selectedData]
  );
  const handleTrigger = () => {
    const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
    dispatch(setTriggerList([
      ...triggerDroppedList, {
        ...currentItem,
        id: uniqueId
      }
    ]))
    navigate(`/create/triggers/${formId || ""}`)


  }
  const watchValues = watch();

  const handleImageDelete = (src, selectedItem) => {
    const updatedMedia = selectedItem?.data?.media.filter(
      (media) => media.path !== src
    );

    const updatedData = { media: updatedMedia };

    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };

  const handleFileChange = (file, setIsLoading) => {
    handleFile(file, droppedItems, selectedData, dispatch, setDroppedItems, setIsLoading);;
    dispatch(setPublish(true));
  };

  const handleOpenImage = (src) => {
    window.open(src, "__blank");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData: watchValues }));
      // dispatch(setPublish(true));
    }, 500);

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, [watchValues, selectedData]);

  return (
    <>
      <SectionField
        placeholder="Please enter your question here."
        message="Required"
        hideRequired
      />
      <div
        className={styles?.instructionsForm}
      >
        <h4>Instructions</h4>
        <div className={styles?.formField}>
          <Controller
            name="instructions"
            control={control}
            render={({ field }) => (
              <InputTextArea
                {...field}
                control={control}
                type="textarea"
                placeholder="Optional"
                onChange={(e) => {
                  field.onChange(e);
                  if (e.target.value) setValue("showInstructions", false);
                }}
                className={styles.textArea}
              />
            )}
          />
        </div>
        <div className={styles?.formField}>
          {currentItem?.data?.media?.length ? (
            <div className={styles.imageContainer}>
              {currentItem?.data?.media?.map((src, index) => (
                <div
                  className={styles.imageWrapper}
                  onClick={() => handleOpenImage(src.path)}
                >
                  <img src={src.path} alt="" />
                  <div
                    className={styles.cancelIcon}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleImageDelete(src.path, currentItem);
                    }}
                  >
                    <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <FileUploadButton
              name="mediaFile"
              control={control}
              onFileChange={handleFileChange}
            />
          )}
        </div>
      </div>

      <form className={styles.formContainer}>
        {/* Checkbox: Show Instructions by Default */}
        <div>
          <label>
            <input
              type="checkbox"
              {...register("showInstructions")}
              disabled={
                !watch("instructions") && !currentItem?.data?.media?.length > 0
              }
            />
            Show instructions by default
          </label>
        </div>
        <div
          style={{ margin: "10px 0px" }}
          onClick={() => {
            if (formId && !publish) {
              navigate(`/scoring/${formId}/formula/${selectedData?.id}`);
            } else {
              toast?.error("Please Publish the Changes!");
            }
          }}
        >
          <Button style={{ width: "100%" }} outline={true}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <CalculateOutlinedIcon />
              Go to Formula
            </div>
          </Button>
        </div>

        {/* Button: Create Trigger */}
        <TriggerButton handleClick={() => {
          if (!publish) {
            handleTrigger()
          } else {
            toast.error("There are unpublished changes");
          }
        }

        } />
      </form>
    </>
  );
};

export default FormulaComponent;
